import { render, staticRenderFns } from "./LoadingItems.vue?vue&type=template&id=4bed4610&scoped=true&"
import script from "./LoadingItems.vue?vue&type=script&lang=js&"
export * from "./LoadingItems.vue?vue&type=script&lang=js&"
import style0 from "./LoadingItems.vue?vue&type=style&index=0&id=4bed4610&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bed4610",
  null
  
)

export default component.exports